module.exports = __webpack_public_path__ + "static/media/office-lunch-catering-3.72d2a8d3.jpg";